import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { getToken } from './utils/auth'
import { reportFromAxiosError } from './utils/frontendMonitor'
import { initPresence } from './utils/presence'
import './assets/css/tailwind.css'
import './assets/css/styles.css'

axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    reportFromAxiosError(error);
    return Promise.reject(error);
  }
);

const app = createApp(App)
const head = createHead()
app.use(head)
app.use(router)
app.mount('#app')
initPresence()